module.exports = {"340203002":"中南街道","340203004":"马塘街道","340203005":"瀂港街道","340203006":"火龙街道","340203007":"白马街道","340203008":"南瑞街道","340203400":"芜湖高新技术产业开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340203.json
// module id = 1151
// module chunks = 0